import { useState } from "react";
import { toast } from "sonner";
import { Link2, MessageCircle } from "lucide-react";
import { api, errMsg } from "@/lib/api";

export const ShareButtons = ({ makeUrl, text: label, phone = "" }) => {
  const [busy, setBusy] = useState(false);

  const whatsapp = async () => {
    const win = window.open("", "_blank");
    setBusy(true);
    try {
      const url = await makeUrl();
      const text = `${label}:\n${url}`;
      const wa = `https://wa.me/${phone}?text=${encodeURIComponent(text)}`;
      if (win) win.location.href = wa; else window.location.href = wa;
    } catch (ex) {
      win?.close();
      toast.error(errMsg(ex));
    } finally {
      setBusy(false);
    }
  };

  const copy = async () => {
    try {
      const url = await makeUrl();
      await navigator.clipboard.writeText(url);
      toast.success("Link copied · valid for 30 days");
    } catch (ex) {
      toast.error(errMsg(ex));
    }
  };

  return (
    <>
      <button data-testid="share-copy-btn" onClick={copy} title="Copy share link"
        className="h-9 w-9 grid place-items-center border border-white/30 hover:bg-white hover:text-slate-900 transition-colors">
        <Link2 size={15} />
      </button>
      <button data-testid="share-whatsapp-btn" onClick={whatsapp} disabled={busy}
        className="h-9 px-3 bg-[#25D366] text-slate-900 font-bold flex items-center gap-2 hover:bg-[#3ee07a] transition-colors disabled:opacity-60">
        <MessageCircle size={15} /> WhatsApp
      </button>
    </>
  );
};
